import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    signal,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import {MenuItem, MessageService} from 'primeng/api';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {TramiteService} from '../../../users/tramites/services/tramite.service';
import {LoginServices} from '../../../auth/login/services/login.service';
import {FileUtilsService} from '../../services/file-utils-service';
import {FileUpload, FileUploadModule} from 'primeng/fileupload';
import {filter} from 'rxjs';
import {
    ArchivoRequisitoInterface, ArchivosHabilitarRq,
    TramiteItem,
    TramiteRequisitoRq,
    TramiteRequisitosRqInterface,
} from '../../../users/tramites/components/interfaces/tramites.interface';
import {CatalogoInterface} from '../../../users/interfaces/proyecto.interface';
import {UserSessionReq} from '../../interfaces/user-session-req-interface';
import {FileHash, FileQueueItem} from '../../interfaces/file-utils-interface';
import {SdetTramiteService} from '../../../users/tramites/services/sdet-tramite.service';
import Swal from 'sweetalert2';
import {SharedModule} from '../../shared.module';
import {NgClass, NgForOf, NgIf, NgStyle} from '@angular/common';
import {TooltipModule} from 'primeng/tooltip';
import {ProgressBarModule} from 'primeng/progressbar';
import {InputGroupModule} from 'primeng/inputgroup';
import {FormsModule} from '@angular/forms';
import {CatalogoService} from '../../services/catalogo-service';
import {InputTextModule} from 'primeng/inputtext';
import {isNumeric} from '../../services/utils-service';
import {RqText} from './rq-text/rq-text';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import {FieldsParserService} from './rq-form/services/fields-parser.service';
import {RqFormComponent} from './rq-form/rq-form.component';
import {CardModule} from 'primeng/card';
import {DropdownModule} from 'primeng/dropdown';
import {SolicitudRequisitoItem} from '../../interfaces/shared-interface';
import {ViewerImgComponent} from '../viewer-img/viewer-img.component';
import {MenuModule} from 'primeng/menu';
import {ViewerPdfComponent} from '../viewer-pdf/viewer-pdf.component';
import {ViewerInterface} from '../../interfaces/viewer-interface';
import {UploadCarnetComponent} from "../upload-fotografia-digital/upload-fotografia-digital.component";
import {useEffect} from 'src/utils/useEffect';
import {ProyectoService} from "../../../users/proyectos/services/proyecto.service";

@Component({
    selector: 'solicitud-requisitos',
    standalone: true,
    templateUrl: './solicitud-requisitos.component.html',
    imports: [
        SharedModule,
        NgForOf,
        NgIf,
        TooltipModule,
        NgClass,
        NgStyle,
        ProgressBarModule,
        FileUploadModule,
        InputGroupModule,
        FormsModule,
        InputTextModule,
        RqText,
        ConfirmPopupModule,
        RqFormComponent,
        CardModule,
        DropdownModule,
        ViewerImgComponent,
        MenuModule,
        ViewerPdfComponent,
        UploadCarnetComponent,

    ],
    providers: [FieldsParserService],
    styleUrl: './solicitud-requisitos.component.scss',
})
export class SolicitudRequisitosComponent implements OnInit {
    /**
     * Servicio recibido como parametro
     */
    errorMessages: {
        [key: string]: { severity: string; summary: string; detail: string }[];
    } = {};
    selected: TramiteItem = null!;
    requisitosArchivos: ArchivoRequisitoInterface[] = [];
    hashDelArchivo: string | any | null = null;
    @Input() showLoader: boolean = false;
    @Input() readOnly: boolean = false;
    @Input() loading!: TemplateRef<any>;
    @Input() datosCargados!: boolean;
    @Input('requisitos') payload: TramiteRequisitosRqInterface[] = [];
    @Input('idProyecto') idProyecto: string | null = null;
    @Input('idSolicitud') idSolicitud: string | null = null;
    @Input('idTramite') idTramite?: string | null = null;
    @Input('isRp') isRp?: boolean | null = null;
    @Output('onEventEmitterSelected')
    onEventEmitterSelected: EventEmitter<TramiteItem> =
        new EventEmitter<TramiteItem>();
    @ViewChild('cargaArchivos') cargaArchivos: FileUpload | any;
    progressBar: { [param: string]: number } = {};
    menuItems: MenuItem[] = [];
    requisitosSelected!: TramiteRequisitoRq;
    viewer!: ViewerInterface;
    displayImgView: boolean = false;
    dialogPdfView: boolean = false;
    /** Usualmente definidos para recibir los datos de los inputs o datos cambiantes por rastreo signals */
    private _isIdRQueue = signal<boolean>(false);
    private _isUploadDisabled = signal(false);
    /** Usualmente definidos para ser utilizados en el html */
    public isIdRQueue: boolean = false
    public isUploadDisabled: boolean = false;
    datosHabilitarRq: ArchivosHabilitarRq [] = [];

    constructor(
        private messageService: MessageService,
        public router: Router,
        private catalogoService: CatalogoService,
        protected tramiteService: TramiteService,
        private loginServices: LoginServices,
        protected fileUtilsService: FileUtilsService,
        private sdetTramiteService: SdetTramiteService,
        private proyectoService: ProyectoService
    ) {
        useEffect(() => {
            this.isIdRQueue = this._isIdRQueue();
        }, [() => this._isIdRQueue()]);
    }

    ngOnInit(): void {
        this.getTipoArchivos();
        console.log(`ngOnInit() ->` + this.constructor.name);
        this.fileUtilsService.fileQueue.set([]);
        this.showLoader = false;
        console.log(`#DEBUG fileQueue cleared on navigation event`);
        this.menuItemsOp();
    }

    menuItemsOp() {
        this.menuItems = [
            {
                label: 'Opciones',
                items: [
                    {
                        label: 'Visualizar',
                        icon: this.iconView(this.requisitosSelected),
                        visible: this.loginServices.hasRoles(['ministro', 'gerente', 'jefe', 'tecnico_resolutor', 'cliente_ventanilla',
                        ]),
                        disabled: this.isVisualizarDisabled(this.requisitosSelected),
                        command: () => this.openViewer(this.requisitosSelected),
                    },
                    {
                        label: 'Habilitar subsanación',
                        icon: 'pi pi-undo',
                        visible: this.loginServices.hasRoles(['gerente', 'jefe', 'tecnico_resolutor']),
                        disabled: this.requisitosSelected.idArchivoEstadoRq == null,
                        command: () => {
                            Swal.fire({
                                title: "¿Está seguro que desea habilitar el requisito?",
                                html: `<small>Esta acción habilitará la subsanación para el requisito seleccionado</small>`,
                                icon: 'question',
                                showDenyButton: true,
                                showCancelButton: false,
                                confirmButtonText: "Sí, confirmar",
                                denyButtonText: "No, cancelar",
                                confirmButtonColor: "#28a745"
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.habilitarRqArchivo(this.requisitosSelected);
                                }
                            });
                        },
                    }
                ]
            },
        ];
    }

    /**
     * Maneja la carga de archivos desde un input de tipo file
     * @param file Archivo seleccionado
     * @param cargaArchivos Componente FileUpload de PrimeNG
     * @param idRequisito Identificador del requisito al que pertenece el archivo
     */
    async handleFile(file: File, cargaArchivos: FileUpload | any, idRequisito: string) {
        // Creamos un "evento" compatible con PrimeNG FileUpload
        const fakeEvent = {
            files: [file],
            /* target: {
                files: [file]
            },
            currentTarget: {
                files: [file]
            },
            type: 'upload' */
        };
        this.onFileUpload(fakeEvent, cargaArchivos, idRequisito);
    }

    //0. Seleccion de archivos
    async onFileUpload(
        event: any,
        cargaArchivos: FileUpload | any,
        idRequisito: string
    ) {
        if (event == null) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'Seleccion invalida',
            });
            return;
        }
        // console.log('Imagen como File:', event);
        // Obtener el tipo archivos permitido
        let allowedTypes = this.fileUtilsService.getAllowedMimeTypes();
        let formatoCompatible = this.fileUtilsService.formatoArchivo;
        // Buscar el requisito específico en el payload
        const requisito = this.payload
            .flatMap(tipo => tipo.requisitos)
            .find(req => req.idRequisito.toString() == idRequisito);
        // Validar si el nombre del requisito contiene 'RP_FOTO' O 'RP_LOGO' y el proyecto es RP
        if (this.isRp && requisito && (requisito.nombre.includes('RP_FOTO') || requisito.nombre.includes('RP_LOGO'))) {
            allowedTypes.length = 0;
            allowedTypes.push('image/jpeg', 'image/png', 'image/bmp');
            formatoCompatible = '.jpeg, .jpg, .png, .bmp';
        }
        const archivo = event.files[0];
        const ext = archivo.name.toLowerCase().slice(archivo.name.lastIndexOf('.')).trim();
        const extensiones = this.fileUtilsService.formatoArchivo.split(',').map(e => e.trim());
        const tipos = this.fileUtilsService.getMimeTypes(ext);
        if (!tipos.includes(archivo.type) && !extensiones.includes(ext)) {
            this.errorMessages[idRequisito] = [{
                severity: 'error',
                summary: 'Formato inválido',
                detail: `Adjuntar un archivo con un formato compatible (${formatoCompatible}).`
            }];
            cargaArchivos.clear();
            return;
        }
        // if (!allowedTypes.includes(event.files[0].type)) {
        //     // Verificar el tipo del archivo
        //     this.errorMessages[idRequisito] = [
        //         {
        //             severity: 'error',
        //             summary: 'Formato inválido',
        //             detail: `Adjuntar un archivo con un formato compatible ${formatoCompatible}.`,
        //         },
        //     ];
        //     cargaArchivos.clear();
        //     return;
        // }
        // Verificar el tamaño del archivo
        if (event.files[0].size > this.fileUtilsService.maxFileSize) {
            this.errorMessages[idRequisito] = [
                {
                    severity: 'error',
                    summary: 'Archivo demasiado grande',
                    detail: `El archivo supera el tamaño máximo permitido de ${
                        this.fileUtilsService.maxFileSize / 250000000
                    } MB.`,
                },
            ];
            cargaArchivos.clear();
            return;
        }
        const estado = await this.fileUtilsService.fileUploadToBuffer(
            event,
            cargaArchivos
        );
        this.hashDelArchivo = this.fileUtilsService.hash;
        //this.showLoader = true;
        if (estado != 1) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'Archivo no cargado, fallo el proceso de carga',
            });
            cargaArchivos.clear();
            this.showLoader = false;
            return;
        }
        await this.onFileSelected(true, cargaArchivos, idRequisito);
        this.showLoader = false;
        // console.log("Archivo cargado correctamente", this.hashDelArchivo);
        cargaArchivos.clear();
    }

    //1. Verificacion y agregar archivo a cola de procesamiento
    async onFileSelected(
        autoAgregar: boolean = false,
        cargaArchivos: FileUpload | any,
        idRequisito: string
    ) {
        // console.log(
        //     `onFileSelected -> autoAgregar: ${autoAgregar}, cargaArchivos: ${
        //         cargaArchivos != null
        //     }, idRequisito: ${idRequisito}`
        // );
        this.clearErrorMessage(idRequisito);
        try {
            this.showLoader = true;
            if (!this.hashDelArchivo) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'No fue posible seleccionar el archivo',
                    showConfirmButton: true,
                    timer: 5000,
                }).then((result) => {
                    console.error(
                        `No fue posible seleccionar el archivo [${this.hashDelArchivo}]`
                    );
                });
                return;
            }
            this.showLoader = true;
            const hash = new FileHash(
                this.hashDelArchivo,
                Number.parseFloat(this.idProyecto!)
            );
            let creado_por = this.loginServices.session()?.perfil.usuario;
            if (this.fileUtilsService.isHashInQueue(hash.hash)) {
                this.duplicatedFileError(
                    'Archivo especificado ya se encuentra en la lista'
                );
                this.showLoader = false;
                return;
            }
            this.fileUtilsService.verificar(hash).subscribe({
                next: (result) => {
                    // console.log(`check start [${hash.hash}]`);
                    if (result.status == 400 || result.status == 409) {
                        this.duplicatedFileError();
                        return;
                    }
                    if (result.status == 200 || result.status == 201) {
                        // console.log(`check ok [${hash.hash}]`);
                        let idArchivoTipo = this.obtenerId(
                            this.fileUtilsService.archivoTipo()
                        );
                        this.requisitosArchivos = [
                            {
                                creadoPor: creado_por?.toString(),
                                nombreArchivo: this.fileUtilsService.file.name,
                                archivo: this.fileUtilsService.file,
                                hash: this.hashDelArchivo,
                                idTipoArchivo: idArchivoTipo!,
                                idSolicitud: '0',
                                idRequisito: idRequisito,
                            },
                        ];
                        const session: UserSessionReq = {
                            uniqueId:
                            this.loginServices.session()?.perfil?.uniqueId,
                            usuario:
                            this.loginServices.session()?.perfil?.usuario,
                            documento:
                            this.loginServices.session()?.perfil?.documento,
                            correo: this.loginServices.session()?.perfil
                                ?.correo,
                        };
                        for (let i of this.requisitosArchivos) {
                            const formData = new FormData();
                            formData.append(
                                'idTipoArchivo',
                                i.idTipoArchivo!.toString()
                            );
                            formData.append('nombre', i.nombreArchivo!);
                            formData.append('file', i.archivo!);
                            formData.append('hash', i.hash!);
                            formData.append('usuario', i.creadoPor!);
                            formData.append(
                                'idProyecto',
                                this.idProyecto!.toString()
                            );
                            formData.append(
                                'idSolicitud',
                                this.idSolicitud!.toString()
                            );
                            formData.append(
                                'idInstitucion',
                                this.loginServices
                                    .session()
                                    ?.perfil?.idInstitucion.toString()!
                            );
                            formData.append(
                                'idRequisito',
                                i.idRequisito!.toString()
                            );
                            formData.append('uniqueId', session.uniqueId!);
                            formData.append('correo', session.correo!);
                            formData.append('documento', session.documento!);
                            const fileItem: FileQueueItem = {
                                frm: formData,
                                hash: hash.hash,
                                progress: 0,
                                status: 'pending',
                            };
                            this.fileUtilsService.addItemToQueue(fileItem);
                            this._isIdRQueue.set(false);
                            this.showLoader = false;
                        }
                    }
                },
                error: (error) => {
                    console.log(`check fail [${hash.hash}]`);
                    console.log(error);
                    cargaArchivos.clear();
                    this.duplicatedFileError();
                    this._isIdRQueue.set(false);
                    this.showLoader = false;
                },
                complete: () => {
                    console.log(
                        `files in queue:${
                            this.fileUtilsService.fileQueue().length
                        }`
                    );
                    this._isIdRQueue.set(this.fileUtilsService.fileQueue().some(item => Number.parseFloat(<string>item.frm.get("idRequisito")) === Number.parseInt(idRequisito)))
                    this.showLoader = false;
                },
            });
        } catch (e) {
            console.log(e);
            this.showLoader = false;
        }
    }

    //2. Procesar archivos y controlar progreso de carga y estado
    onFileQueueProcessItems(idRequisitoParam?: string) {
        // console.log(`idRequisito ->${idRequisitoParam}`);
        this.showLoader = true;
        if (!this.fileUtilsService.fileQueue()) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'Archivos invalidos o no encontrados',
            });
            return;
        }
        let queueItems;
        if (idRequisitoParam && isNumeric(idRequisitoParam)) {
            //Filtrar y procesar solo el requisito proveido.
            queueItems = this.fileUtilsService
                .fileQueue()
                .filter(
                    (item) =>
                        Number.parseFloat(
                            <string>item.frm.get('idRequisito')
                        ) === Number.parseFloat(idRequisitoParam)
                );
        } else {
            //Procesar todos los requisitos
            queueItems = this.fileUtilsService.fileQueue();
        }
        if (queueItems == undefined || queueItems.length == 0) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'Archivos invalidos o no encontrados',
            });
            this.showLoader = false;
            return;
        }
        // console.log(`queueItems: ${queueItems}`);
        queueItems.forEach((file: FileQueueItem) => {
            // console.log(`Processing file:${file.hash}`);
            let idRequisito = Number.parseFloat(
                <string>file.frm.get('idRequisito')
            );
            this.fileUtilsService.upload(file).subscribe({
                next: (result) => {
                    if (result) {
                        if (result.status == 409) {
                            this.duplicatedFileError();
                        }
                        if (result.type === 'progress') {
                            if (result.progress % 20 === 0) {
                                console.log(
                                    `#DEBUG Upload progress: ${result.progress}% for ${file.hash}`
                                );
                            }
                            this.updateProgressBar(
                                idRequisito!,
                                result.progress
                            );
                            if (result.progress == 100) {
                                console.log('#DEBUG Upload done!!!');
                            }
                        } else if (result.type === 'response') {
                            this.fileUtilsService.removeItemFromQueue(
                                idRequisito.toString()!
                            ); //Remover de la cola cuando finalice la carga
                            console.log(
                                `#DEBUG Upload completed for: ${file.hash}%`
                            );
                            if (isNumeric(idRequisitoParam)) {
                                //Consultar por cada requisito procesado individualmente.
                                this.tramiteService.getRequisitosPorParametros(
                                    this.idTramite!,
                                    this.idProyecto!,
                                    null
                                );
                                this.getSdetItem(
                                    this.idProyecto!,
                                    this.idTramite!
                                );
                            } else {
                                //Consultar solo una vez cuando se han procesado todos los requisitos.
                                if (
                                    this.fileUtilsService.fileQueue().length ==
                                    0
                                ) {
                                    this.tramiteService.getRequisitosPorParametros(
                                        this.idTramite!,
                                        this.idProyecto!,
                                        null
                                    );
                                    this.getSdetItem(
                                        this.idProyecto!,
                                        this.idTramite!
                                    );
                                    setTimeout(() => {
                                        this.showLoader = false;
                                    }, 300);
                                }
                            }
                        }
                    }
                },
                error: (error) => {
                    if (error.status == 413) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text:
                                'El archivo supera el tamaño máximo permitido de ' +
                                this.fileUtilsService.maxFileSize / 20000000 +
                                ' MB',
                            showDenyButton: true,
                            showConfirmButton: false,
                            denyButtonText: `Ok`,
                        });
                    } else {
                        let text = error.mensaje;
                        if (error.error && error.error.mensaje) {
                            text = error.error.mensaje; // Extract the custom message
                        } else if (error.message) {
                            text = error.message; // Fallback to the general error message
                        }
                        if (text.includes('api')) {
                            text =
                                'Ocurrió un error al procesar, intente mas tarde';
                        }
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: text
                                ? text
                                : 'Ocurrió un error al procesar, intente mas tarde',
                            showDenyButton: true,
                            showConfirmButton: false,
                            denyButtonText: `Ok`,
                        });
                    }
                    this.showLoader = false;
                },
                complete: () => {
                    this.fileUtilsService.removeItemFromQueue(
                        idRequisito.toString()!
                    ); //Remover de la cola cuando finalice la carga
                    this.messageService.add({
                        severity: 'success',
                        summary: '',
                        detail: `[${file.frm.get(
                            'nombre'
                        )}] guardado correctamente`,
                    });
                    if (this.showLoader) {
                        this.showLoader = false;
                    }
                },
            });
        });
    }

    getTipoArchivos() {
        if (
            !this.fileUtilsService.archivoTipo() ||
            this.fileUtilsService.archivoTipo().length <= 0
        ) {
            this.catalogoService
                .getCatalogoFromCache('archivo_tipo')
                .subscribe({
                    next: (result) => {
                        this.fileUtilsService.archivoTipo.set(result!);
                    },
                    error: (error) => {
                    },
                    complete: () => {
                        console.log(`archivo_tipo ->` + this.constructor.name);
                    },
                });
        }
    }

    /**
     * Obtener el id del tipo de archivo*/
    obtenerId(items: CatalogoInterface[]) {
        if (items.length == 0) return null;
        let idArchivo: string | number | null = null;
        idArchivo =
            items.find(
                (tipo) =>
                    tipo.id === '9' ||
                    tipo.descripcion === 'Documentos y formularios'
            )?.id || null;
        return idArchivo;
    }

    private getSdetItem(idProyecto: string, idTramite: string) {
        this.sdetTramiteService
            .obtenerSdetItem(idProyecto!, idTramite!)
            .subscribe((resp) => {
                this.selected = resp.body!;
                this.onEventEmitterSelected.emit(this.selected);
            });
    }

    private duplicatedFileError(customError?: string) {
        let error = 'Archivo ya existe en el proyecto especificado';
        if (customError) {
            error = customError;
        }
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error,
            showConfirmButton: true,
            timer: 2000,
        }).then((r) => console.error(error));
        this.showLoader = false;
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: Event): void {
        console.log('Page refresh detected');
        this.fileUtilsService.fileQueue.set([]);
        this.showLoader = false;
        this.router.events
            .pipe(
                filter(
                    (revent) =>
                        revent instanceof NavigationStart ||
                        revent instanceof NavigationEnd
                )
            )
            .subscribe(() => {
                this.fileUtilsService.fileQueue.set([]);
                this.showLoader = false;
            });
    }

    clearErrorMessage(idRequisito: string) {
        this.errorMessages[idRequisito] = [];
    }

    /**Metodo que sincroniza el progreso de la carga de un archivo, también actualiza el requisito en pantalla que corresponde al archivo*/
    updateProgressBar(idRequisito: number, progress: number) {
        if (this.progressBar != undefined) {
            this.progressBar[idRequisito] = progress;
        }
    }

    /**Metodo que sincroniza el progreso de la carga de un archivo, también actualiza el archivo en pantalla que corresponde al hash proporcionado*/
    updateProgressBarWithHash(hash: string, progress: number) {
        if (this.progressBar != undefined) {
            this.progressBar[hash] = progress;
        }
    }

    onSubmit(payload: { rq: TramiteRequisitoRq; event: Event }): void {
        const {rq} = payload;
        if (!rq || !rq.reqValue) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Campos requeridos',
                showDenyButton: true,
                showConfirmButton: false,
                denyButtonText: `Ok`,
            }).then((r) => console.log('Campos requeridos'));
            return;
        }
        if (this.idSolicitud && this.idProyecto && rq && rq.reqValue) {
            const item: SolicitudRequisitoItem = {
                idSolicitud: this.idSolicitud!,
                idProyecto: this.idProyecto!,
                idRequisito: rq.idRequisito,
                value: rq.reqValue,
                session: {
                    uniqueId: this.loginServices.session()?.perfil.uniqueId,
                    correo: this.loginServices.session()?.perfil.correo,
                    usuario: this.loginServices.session()?.perfil.usuario!,
                    documento: this.loginServices.session()?.perfil.documento,
                },
            };
            this.sdetTramiteService.actualizar(item).subscribe({
                next: (result) => {
                    if (result) {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: rq.nombre + ' procesado correctamente',
                            showConfirmButton: true,
                        });
                    }
                    console.log('ONSUBMIT->', result);
                },
                error: (error) => {
                    let text = error.mensaje;
                    if (error.error && error.error.mensaje) {
                        text = error.error.mensaje; // Extract the custom message
                    } else if (error.message) {
                        text = error.message; // Fallback to the general error message
                    }
                    if (text.includes('api')) {
                        text =
                            'Ocurrió un error al procesar, intente mas tarde';
                    }
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: text
                            ? text
                            : 'Ocurrió un error al procesar, intente mas tarde',
                        showDenyButton: true,
                        showConfirmButton: false,
                        denyButtonText: `Ok`,
                    });
                    console.log(error);
                },
                complete: () => {
                    /**
                     * TODO: Se detecto un bug para obtener la informacion actualizada cuando se completan los requisitos de tipo text y form las estadisticas en la respuesta no reflejan los ultimos cambios de los requisitos completados 13/01/2025
                     * Este proceso se refleja cuando se completan los requisitos tipo text y form de ultimo*/
                    this.tramiteService.getRequisitosPorParametros(
                        this.idTramite!,
                        this.idProyecto!,
                        null
                    );
                    this.getSdetItem(this.idProyecto!, this.idTramite!);
                },
            });
        }
    }

    private openViewer(requisitosSelected: TramiteRequisitoRq) {
        // console.log('openViewer ->', requisitosSelected);
        if (requisitosSelected !== null) {
            if (
                requisitosSelected.hash !== null ||
                requisitosSelected.hash !== '' ||
                requisitosSelected.ext !== null
            ) {
                // console.log('openViewer -> entramos a visualizar');
                this.viewer = {
                    idRequisito: requisitosSelected.idRequisito,
                    nombre: requisitosSelected.nombre!,
                    hash: requisitosSelected.hash!,
                    idTipoArchivo: requisitosSelected.idTipoArchivo!,
                    ext: requisitosSelected.ext!,
                };
                if (
                    requisitosSelected.ext === '.jpeg' ||
                    requisitosSelected.ext === '.jpg' ||
                    requisitosSelected.ext === '.png'
                ) {
                    //
                    this.displayImgView = true;
                }
                if (requisitosSelected.ext === '.pdf') {
                    this.dialogPdfView = true;
                }
            } else {
                console.log('no se puede visualizar el archivo');
            }
        }
    }

    setRequisitos(requisitoDto: TramiteRequisitoRq) {
        this.requisitosSelected = requisitoDto;
        this.menuItemsOp(); //llamando el menu cada vez que cambie requisitosSelected y aplicar validacion isVisualizarDisabled
    }

    closeViewerPdf(event: boolean): void {
        this.dialogPdfView = event;
    }

    closeViewerImg(event: boolean): void {
        this.displayImgView = event;
    }

    isVisualizarDisabled(requisitosSelected: TramiteRequisitoRq): boolean {
        let hash = '';
        if (requisitosSelected) {
            hash = requisitosSelected.hash!;
        }
        return !hash;
    }

    iconView(requisitosSelected: TramiteRequisitoRq): string {
        let icon = 'pi pi-ban';
        if (requisitosSelected) {
            if (
                requisitosSelected.ext == '.jpeg' ||
                requisitosSelected.ext === '.jpg'
            ) {
                icon = 'pi pi-image';
                return icon;
            }
            if (requisitosSelected.ext === '.pdf') {
                icon = 'pi pi-file-pdf';
                return icon;
            }
        }
        return icon;
    }

    handleBase64(base64: string): void {
        // Usar si necesitas mostrar o guardar en BD
    }

    /**
     * Verifica si un requisito es de tipo foto o logo
     * @param idRequisito
     * @returns boolean
     */
    public isRequisitoTipoFoto(idRequisito: string): boolean {
        const requisito = this.payload.flatMap(tipo => tipo.requisitos).find(req => req.idRequisito.toString() == idRequisito);
        // Si no se encuentra el requisito, retornamos false
        if (!requisito) {
            return false;
        }
        // Si es un requisito de tipo foto, se retorna true o false
        return (requisito && (requisito.nombre.includes('RP_FOTO') || requisito.nombre.includes('RP_LOGO')));
    }

    private habilitarRqArchivo(requisitosSelected: TramiteRequisitoRq) {
        console.log("requisitosSelected", requisitosSelected);
        if (requisitosSelected == null) {
            console.log("Requisito seleccionado es null o vacio: ", requisitosSelected);
            return;
        }
        let idsRequisitos: number[] = [];
        if (!idsRequisitos) {
            idsRequisitos = null!;
        }
        idsRequisitos.push(parseInt(requisitosSelected.idRequisito));
        const archivosHabilitarRq: ArchivosHabilitarRq = {
            idProyecto: parseInt(this.tramiteService.idProyecto()!),
            idSolicitud: 0,
            idsRequisito: idsRequisitos,
            session: {
                uniqueId: this.loginServices.session()?.perfil.uniqueId,
                correo: this.loginServices.session()?.perfil.correo,
                usuario: this.loginServices.session()?.perfil.usuario!,
                documento: this.loginServices.session()?.perfil.documento,
            },
            descripcion: ""
        };
        this.datosHabilitarRq.push(archivosHabilitarRq);
        if (this.datosHabilitarRq.length > 0) {
            this.actualizarArchivosRq(this.datosHabilitarRq);
        }
    }

    actualizarArchivosRq(tramiteRequisitoRq:ArchivosHabilitarRq[]){
     this.proyectoService.actualizarArchivosRq(tramiteRequisitoRq).subscribe({
         next: (result) => {
             if (result) {
                 this.tramiteService.getRequisitosPorParametros(
                     this.idTramite!,
                     this.idProyecto!,
                     null
                 );
                 this.getSdetItem(
                     this.idProyecto!,
                     this.idTramite!
                 );
                 Swal.fire({
                     position: "center",
                     icon: "success",
                     title: "Éxito la se habilitó correctamente el requisito para la subsanación",
                     showConfirmButton: false,
                     timer: 3000
                 })
                 this.datosHabilitarRq=[];
             }
         },
         error: (error) => {
             console.log(error);
             let text = error.mensaje;
             Swal.fire({
                 icon: 'error',
                 title: 'Error',
                 text: text ? text: 'Ocurrió un error al habilitar el requitsito para la subsanación',
                 showDenyButton: true,
                 showConfirmButton: false,
                 denyButtonText: `Ok`,
             });
             this.datosHabilitarRq=[];
         },
         complete: () => {
             this.datosHabilitarRq=[];
         },
     });
    }
}
